<template>
  <div>
    <div v-for="(point, index) in $store.state.event.data.passages_inter.points" :key="index"
      class="container_button_passage">
      <b-button class="button_passage" v-if="point.display === 'true'" v-bind:class="{
        isCurrent: $store.state.event.selection.passage === point.name,
      }">
        <router-link target="_self" :to="{
          name: 'Epreuve',
          query: { id: $store.state.event.id, p: $store.state.event.selection.course, i: point.name },
        }" refresh>{{ point.name }}</router-link>
      </b-button>
    </div>
    <div class="container_button_passage">
      <b-button class="button_passage" v-bind:class="{
        isCurrent: $store.state.event.selection.passage === '',
      }">
        <router-link target="_self" :to="{
          name: 'Epreuve',
          query: { id: $store.state.event.id, p: $store.state.event.selection.course },
        }" refresh>Arrivée</router-link>
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  computed: {

  },
};
</script>

<style>
.container_button_passage {
  display: inline-block;

}

.button_passage {
  padding: 3px 6px;
  font-size: 14px;
}

.button_passage a {
  color: inherit !important;
}

#selector-inter-bar {
  background-color: #e2e2e2;
  border: 1px solid #d8d7d7;
  border-radius: 3px;
  margin: 10px 5px;
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/component/Epreuve/SelectPointIntermediaires.vue